import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'miliSecondToMinutes'
})
export class MiliSecondToMinutesPipe implements PipeTransform {
  transform(value: any, args?: any): string {
    if (value > 0) {
      let minutes = (value / 60000).toFixed(2);
      return `${minutes} mins`;
    } else {
      return '00:00 mins';
    }

  }

}
